exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Water-module__water___uTUat{display:flex;justify-content:center;align-items:center;height:var(--app-height);width:100vw;background-color:#526df6;position:relative;overflow:hidden}.Water-module__water___uTUat .Water-module__left-lilypad___1fbew{position:absolute;left:-40px;bottom:-40px;z-index:0}.Water-module__water___uTUat .Water-module__right-lilypad___1Q5j3{position:absolute;right:-40px;top:-40px;z-index:0}", ""]);

// exports
exports.locals = {
	"water": "Water-module__water___uTUat",
	"left-lilypad": "Water-module__left-lilypad___1fbew",
	"right-lilypad": "Water-module__right-lilypad___1Q5j3"
};